module.exports = __webpack_public_path__ + "img/19_15.a55e7f8f.png";